// Neteja l'HTML que ve de l'admin (descripcions, característiques, etc.)
// abans de fer-lo servir amb dangerouslySetInnerHTML — dues coses
// diferents, totes dues necessàries:
//
// 1) Estètica: molts editors de text enriquit (Word, Google Docs,
//    CKEditor...) hi deixen style="..." inline (font-family, color,
//    mides...) que trepitja el disseny propi de la web. Es treuen
//    style/class i s'aplana <font> (etiqueta obsoleta que sempre porta
//    color/mida inline), conservant-ne el contingut.
//
// 2) Seguretat: dangerouslySetInnerHTML executa qualsevol HTML tal qual,
//    així que es passa per DOMPurify (llista blanca d'etiquetes i
//    atributs HTML; sense SVG/MathML, scripts, handlers on*, ni esquemes
//    perillosos com javascript: en href/src, incloent-hi els trucs amb
//    tabuladors o salts de línia dins de l'esquema).
//
// L'estructura real (negreta, cursiva, llistes, enllaços, paràgrafs) es
// conserva intacta.
import DOMPurify from "dompurify";

const CONFIG = {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ["style", "form", "font"],
    FORBID_ATTR: ["style", "class"],
};

export default function limpiarHtml(html) {
    if (!html) return "";

    return DOMPurify.sanitize(String(html), CONFIG);
}
